import React from 'react';
import { Accordion, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';

// Współdzielone style dla accordion
export const accordionStyles = `
  .accordion-button:not(.collapsed) {
    background-color: rgba(40, 40, 44, 0.95) !important;
    color: white !important;
  }
  .accordion-button:not(.collapsed)::after {
    filter: brightness(0) invert(1);
  }
  .accordion-button:focus {
    box-shadow: none;
    border-color: rgba(255,255,255,0.2);
  }
`;

// Komponent nagłówka strony
export const PageHeader = ({ title, subtitle }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-center mb-5"
    >
      <h1 className="text-white fw-bold mb-3">{title}</h1>
      <p className="text-white-50" style={{ fontSize: '1.2rem' }}>
        {subtitle}
      </p>
    </motion.div>
  );
};

// Komponent karty informacyjnej
export const InfoCard = ({ 
  children, 
  gradient, 
  borderColor, 
  className = '',
  icon,
  title 
}) => {
  const defaultGradient = 'linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(0, 86, 179, 0.1) 100%)';
  const defaultBorder = 'rgba(102, 126, 234, 0.3)';

  return (
    <Card 
      className={`border-0 shadow-lg ${className}`}
      style={{ 
        borderRadius: '20px',
        background: gradient || defaultGradient,
        border: `2px solid ${borderColor || defaultBorder}`
      }}
    >
      <Card.Body className="p-4">
        {title && (
          <h5 className="fw-bold mb-3 text-white">
            {icon && <span className="me-2" style={{ display: 'inline-flex', alignItems: 'center' }}>{icon}</span>}
            {title}
          </h5>
        )}
        {children}
      </Card.Body>
    </Card>
  );
};


// Komponent pojedynczego elementu accordion
export const AccordionScenario = ({ 
  scenario, 
  index, 
  eventKey,
  argumentLabel = 'Argumentacja pracodawcy',
  responseLabel = 'Asertywna odpowiedź'
}) => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  const argumentContent = scenario.argument || scenario.situation || scenario.threat;
  const hasArgument = argumentContent && argumentLabel;
  const hasResponse = scenario.response && responseLabel;

  return (
    <motion.div
      {...fadeInUp}
      transition={{ delay: index * 0.1 }}
      className="mb-3"
    >
      <Accordion.Item
        eventKey={eventKey}
        style={{
          border: '2px solid rgba(255,255,255,0.2)',
          borderRadius: '20px',
          overflow: 'hidden',
          boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
          background: 'rgba(255,255,255,0.03)',
          scrollMarginTop: '20px'
        }}
      >
        <Accordion.Header
          style={{ borderRadius: '20px' }}
          onClick={(e) => {
            setTimeout(() => {
              const element = e.currentTarget?.closest('.accordion-item');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }, 100);
          }}
        >
          <div className="d-flex align-items-center w-100">
            <div
              className="d-flex align-items-center justify-content-center rounded-circle me-3"
              style={{
                width: '50px',
                height: '50px',
                background: `linear-gradient(135deg, ${scenario.color} 0%, ${scenario.color}dd 100%)`,
                color: 'white',
                flexShrink: 0,
                fontSize: '1.5rem'
              }}
            >
              {scenario.icon}
            </div>
            <h5 className="mb-0 fw-bold text-white">{scenario.title}</h5>
          </div>
        </Accordion.Header>
        <Accordion.Body
          style={{
            background: 'rgba(255,255,255,0.05)',
            backdropFilter: 'blur(10px)',
            padding: '2rem',
            color: 'white'
          }}
        >
          {hasArgument && (
            <div className="mb-4">
              <h6 className="fw-bold mb-3" style={{ fontSize: '1.1rem' }}>
                {argumentLabel}:
              </h6>
              <div className="p-3 rounded" style={{
                background: 'rgba(220, 53, 69, 0.1)',
                border: '2px solid rgba(220, 53, 69, 0.3)',
                borderRadius: '15px'
              }}>
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                  {argumentContent}
                </p>
              </div>
            </div>
          )}
          {hasResponse && (
            <div>
              <h6 className="fw-bold mb-3" style={{ fontSize: '1.1rem' }}>
                {responseLabel}:
              </h6>
              <div className="p-3 rounded" style={{
                background: 'rgba(40, 167, 69, 0.1)',
                border: '2px solid rgba(40, 167, 69, 0.3)',
                borderRadius: '15px'
              }}>
                <p className="mb-0" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                  "{scenario.response}"
                </p>
              </div>
            </div>
          )}
        </Accordion.Body>
      </Accordion.Item>
    </motion.div>
  );
};

// Komponent kontenera strony
export const PageContainer = ({ children }) => {
  return (
    <div style={{
      minHeight: '100vh',
      paddingTop: '2rem',
      paddingBottom: '4rem',
      width: '100%'
    }}>
      {children}
    </div>
  );
};

// Komponent animowanej sekcji
export const AnimatedSection = ({ children, delay = 0 }) => {
  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  return (
    <motion.div
      {...fadeInUp}
      transition={{ delay }}
      style={{marginBottom: '1rem'}}
    >
      {children}
    </motion.div>
  );
};

